import React, { useRef } from "react";

type FilePickerProps = {
  onFileSelect: (file: File) => void;
  transformFile?: (file: File) => Promise<File>;
  label?: string;
  accept?: string;
};

const FilePicker: React.FC<FilePickerProps> = ({
  onFileSelect,
  transformFile,
  label,
  accept,
}) => {
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = e.target.files?.[0] || null;
    if (selectedFile) {
      if (transformFile) await transformFile(selectedFile);
      onFileSelect(selectedFile);
    }
  };

  const handleButtonClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <div>
      <button onClick={handleButtonClick}>{label || "파일 선택"}</button>
      <input
        ref={fileInputRef}
        type="file"
        accept={accept}
        onChange={handleFileChange}
        style={{ display: "none" }}
      />
    </div>
  );
};

export default FilePicker;
